
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

export default function FormCalendar() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [dateSelect, setDateSelect] = useState({ date_start: null, date_end: null });

    const editorRef = useRef(null);

    const defaultdetail = {
        author_id: user.data.id, title: '', status: 1, type: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "calendar/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                const date_start = res.data.data.date_start
                                const date_end = res.data.data.date_end
                                setDateSelect({ date_start: date_start, date_end: date_end })
                                setDetail(res.data.data);
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tên sự kiện').max(150, "Độ dài không quá 150 ký tự"),
            date_start: Yup.string().trim().nullable().required('Nhập thời gian bắt đầu'),
            date_end: Yup.string().trim().nullable().required('Nhập thời gian kết thúc'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            const content = editorRef.current?.getContent();
            values.calendar_content = content
            // values.list_images = imagePreviews
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'calendar/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập sự kiện thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'calendar', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới sự kiện thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const handleDate = (name, value) => {
        formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
        formik.setFieldTouched(name)
        let newDate = Object.assign({}, dateSelect)
        newDate[name] = value
        setDateSelect(newDate)
    };

    return (
        <AkkhorLayout idrole="calendar">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/calendar">Danh sách sự kiện</Link>
                    </li>
                    <li>{id ? 'Sửa sự kiện' : 'Thêm mới sự kiện'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Sự kiện</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-lg-6 col-12 form-group">
                                <label>Tên sự kiện <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-sm-3 col-12 form-group ">
                                <label>Ngày bắt đầu</label>
                                <DateTimePicker onChange={(value) => { handleDate('date_start', value) }} value={dateSelect.date_start ? new Date(dateSelect.date_start) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                <AlertErrorForm formik={formik} name="date_start"></AlertErrorForm>
                            </div>
                            <div className="col-sm-3 col-12 form-group ">
                                <label>Giờ bắt đầu</label>
                                <input type="time" className="form-control height32" {...formik.getFieldProps("time_start")} />
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-sm-3 col-12 form-group ">
                                <label>Ngày kết thúc</label>
                                <DateTimePicker onChange={(value) => { handleDate('date_end', value) }} value={dateSelect.date_end ? new Date(dateSelect.date_end) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                <AlertErrorForm formik={formik} name="date_end"></AlertErrorForm>
                            </div>
                            <div className="col-sm-3 col-12 form-group ">
                                <label>Giờ kết thúc</label>
                                <input type="time" className="form-control height32" {...formik.getFieldProps("time_end")} />
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-12 col-sm-6">
                                {/* <label>Nội dung</label> */}
                                <div className="w-100 position-relative">
                                    {/* <Editor
                                        apiKey="8vzg9hkuturhxampptav8epspf6gw56ny951lc2o70rehku4"
                                        onInit={(evt, editor) => editorRef.current = editor}
                                        onBlur={handleBlur}
                                        init={{
                                            height: 300,
                                            menubar: false,
                                            plugins: [
                                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'emoticons'
                                            ],
                                            toolbar: 'undo redo | blocks | ' +
                                                'bold italic forecolor | alignleft aligncenter ' +
                                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                                'removeformat | emoticons charmap | code | help',
                                            placeholder: 'Nhập nội dung...',
                                        }}
                                    />
                                    <div className="upload-image-post">
                                        <button className="btn btn-outline-info" onClick={() => fileInputRef.current.click()}>
                                            <i className='fas fa-camera-retro'></i>
                                        </button>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleUploadImage}
                                        />
                                    </div>

                                    <div className="row mt-3">
                                        <div className='col-12 col-sm-6'>
                                            <label className="btn btn-secondary">
                                                Tải lên hình ảnh
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    multiple
                                                    hidden
                                                    onChange={uploadProfilePic}
                                                />
                                            </label>
                                            <br />
                                            {imagePreviews.map((src, index) => (
                                                <div key={index} className='mr-2' style={{ position: "relative", display: "inline-block" }}>
                                                    <img
                                                        src={src}
                                                        alt={`preview-${index}`}
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            objectFit: "cover",
                                                            borderRadius: 8,
                                                            display: "block"
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            const updated = [...imagePreviews];
                                                            updated.splice(index, 1);
                                                            setImagePreviews(updated);
                                                        }}
                                                        style={{
                                                            position: "absolute",
                                                            top: "-6px",
                                                            right: "-6px",
                                                            background: "red",
                                                            border: "none",
                                                            borderRadius: "50%",
                                                            color: "white",
                                                            width: "20px",
                                                            height: "20px",
                                                            fontSize: "12px",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        &times;
                                                    </button>
                                                </div>
                                            ))}
                                            {uploading && <Spinner />}
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-lg-6 col-12 form-group">
                                <label>Trạng thái</label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Khoá</option>
                                    <option value="1">Hoạt động</option>
                                </select>
                            </div>

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
